import { Btn, Breadcrumbs, H4 } from '../../AbstractElements';
import React, { Fragment, useState, useCallback, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { tableColumns } from '../../Data/DataTable/community';
import axios from 'axios';
import EditComm from './EditComm';
import AddComm from './AddComm';
import ViewComm from './ViewComm';
import { ServerPath } from '../../Constant'
import Swal from 'sweetalert2';
import { Button } from 'react-bootstrap';
import { _axios } from '../../utils/axios'; 


const DataTablesContain = () => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${ServerPath}/community`);
                const actualData = response?.data?.data;
                console.log(actualData);
                const userData = actualData.map(trip => ({
                    ...trip,
                    image: <img src={trip.image} alt={trip.image} width="45" height="45" />,
                    // status: <span
                    //     className={`badge rounded-pill ${trip?.status === 1 ? 'badge-success' : 'badge-danger'}`}
                    //     data-bs-toggle="modal"
                    //     data-bs-target=".bd-example-modal-sm"
                    // >
                    //     {trip?.status === 1 ? 'Active' : 'Inactive'}
                    // </span>,
                    dateofpost: formatDate(trip.dateofpost),
                    action: (
                        <div className="action d-flex justify-content-center">
                            <div className="edit" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                                {trip && <ViewComm data={trip} />}
                            </div>
                            <div className="delete">
                                <Button onClick={(e) => handleDeleteID(trip.comm_id, e)} className="btn-square btn btn-danger mx-2"><i className="icon-trash"></i></Button>
                            </div>
                        </div>
                    ),
                }));
                setData(userData);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchData();
    }, []);

    const handleDeleteID = async (commId, event) => {
        event.preventDefault();
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            customClass: {
                container: 'swal2-container'
            }
        });

        if (result.isConfirmed) {
            try {
                await _axios.delete(`${ServerPath}/community/${commId}`);
                setData(prevData => prevData.filter(data => data.comm_id !== commId));
                Swal.fire(
                    'Deleted!',
                    'Your community has been deleted.',
                    'success'
                );
            } catch (error) {
                console.error('Error deleting community:', error);
                Swal.fire(
                    'Error!',
                    'There was an error deleting the community.',
                    'error'
                );
            }
        }
    };

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleDelete = () => {
        if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map(r => r.title)}?`)) {
            setToggleDelet(!toggleDelet);
            setData(data.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true));
            setSelectedRows('');
        }
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <Fragment>
            <div className='row'>
                <div className='col-12 col-md-6 col-lg-6'>
                    <Breadcrumbs mainTitle="Community" parent="Tables" title="Community" />
                </div>
                {/* <div className='col-12 col-md-6 col-lg-6'>
                    <AddComm />
                </div> */}
            </div>
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            {/* <HeadingCommon Heading={DataTableHeading}  /> */}
                            <CardBody className='pt-0'>
                                {(selectedRows.length !== 0) &&
                                    <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                                        <H4 attrH4={{ className: 'text-muted m-0' }}>Delete Selected Data?</H4>
                                        <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                                    </div>
                                }
                                <DataTable
                                    className='data-tables theme-scrollbar pt-4'
                                    data={data}
                                    columns={tableColumns}
                                    striped={true}
                                    center={true}
                                    pagination
                                    selectableRows
                                    onSelectedRowsChange={handleRowSelected}
                                    clearSelectedRows={toggleDelet}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );

};
export default DataTablesContain;